import axios from "axios";
import { getAPIUrl } from "../config";
import { headerConfig } from "./authConfig";
const serviceEndPoint = `${getAPIUrl()}/api/support`;
const servicePerformanceEndPoint = `${getAPIUrl()}/api/performance`;

export const getSupportData = async () => {
  try {
    const result = await axios.get(serviceEndPoint, headerConfig());
    return result.data;
  } catch (error) {
    console.error("Error fetching support data:", error);
    throw error;
  }
};
export const getPerformanceData = async () => {
  try {
    const result = await axios.get(servicePerformanceEndPoint, headerConfig());
    // if (result?.data?.success == false) {
    //   clearLocalStorage();
    // }
    return result.data;
  } catch (error) {
    console.error("Error fetching performance data:", error);
    throw error;
  }
};
export const getLastMonthPerformance = async () => {
  try {
    const result = await axios.get(
      `${servicePerformanceEndPoint}/last-month`,
      headerConfig()
    );
    return result.data;
  } catch (error) {
    console.error("Error fetching last month performance data:", error);
    throw error;
  }
};
export const addSupportData = async (data) => {
  try {
    const result = await axios.post(serviceEndPoint, data, headerConfig());
    return result.data;
  } catch (error) {
    console.error("Error adding support data:", error);
    throw error;
  }
};
export const getUserById = async (id) => {
  try {
    const result = await axios.get(`${serviceEndPoint}/${id}`, headerConfig());
    return result.data;
  } catch (error) {
    console.error(`Error fetching user by ID (${id}):`, error);
    throw error;
  }
};
export const updateSupportData = async (data) => {
  try {
    const result = await axios.put(
      serviceEndPoint,
      {
        id: data._id,
        name: data.name,
        password: data.password,
        email: data.email,
        phone: data.phone,
        active: data.active,
        role: data.role,
      },
      headerConfig()
    );
    return result.data;
  } catch (error) {
    console.error("Error updating support data:", error);
    throw error;
  }
};

export const deleteUser = async (id) => {
  try {
    const result = await axios.delete(serviceEndPoint, {
      data: { id },
      ...headerConfig(),
    });
    return result.data;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};